import React, { FC } from 'react';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import { CashFlowTypeDataEditorProps } from './CashFlowTypeDataEditor.props';
import { CASH_FLOW_TYPE_OPTIONS } from '../data/constants';

// withTooltip erases GridSelect's own prop surface (WithTooltipProps only),
// so passthrough props fail to typecheck without this widening. The sibling
// editors hit the same mismatch; widening here keeps this file error-free.
const Select = GridSelect as unknown as FC<any>;

// `objectOptions` makes GridSelect display labels while committing the raw
// backend value ('invested_capital' | 'proceeds') to the cell.
const CashFlowTypeDataEditor = (props: CashFlowTypeDataEditorProps) => (
  <Select
    menuPosition="fixed"
    usePortal
    options={CASH_FLOW_TYPE_OPTIONS}
    objectOptions={{ valueKey: 'value', displayKey: 'label' }}
    {...props}
  />
);

export default CashFlowTypeDataEditor;
